<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { ArticleDTO } from '@/composables/article/article'
import logo from '@/assets/logo_svg.svg'

const { t } = useI18n()

defineProps<{
  item: ArticleDTO
}>()

const formatDate = (timestamp: number) => {
  if (!timestamp) return ''
  const date = new Date(timestamp)
  return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`
}
</script>

<template>
  <NuxtLink :to="`/article/${item.id}`" class="block bg-white rounded-xl flex gap-4">
    <!-- 缩略图 -->
    <div class="w-20 h-20 bg-gray-100 rounded-lg flex-shrink-0 overflow-hidden flex items-center justify-center">
      <img v-if="item.thumbnailUrl" :src="item.thumbnailUrl" :alt="item.title" class="w-full h-full object-cover" />
      <img v-else :src="logo" alt="" class="w-full h-full object-contain" />
    </div>
    <!-- 右侧内容 -->
    <div class="flex-1 flex flex-col justify-start">
      <div>
        <div class="text-lg font-bold text-gray-900">{{ item.title }}</div>
        <div class="text-base text-gray-400 mt-1">{{ item.author }}</div>
      </div>
      <div class="text-sm text-gray-400 flex items-center space-x-3 mt-1">
        <span>{{ t('article.published_at_prefix') }}{{ formatDate(item.createdAt) }}</span>
        <span>{{ t('article.read_count', { count: item.read ?? 0 }) }}</span>
      </div>
    </div>
  </NuxtLink>
</template>
